import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './List.scss';

const List = ({ content, attrs = {}, setup }) => (
	<div className={[s.list, ...(attrs.className ? attrs.className.map((cN) => s[`list${cN}`]) : [])].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(content.rawText, {}, setup) }} />
);

export default hot(module)(List);
